import { push } from 'react-router-redux';
import { toast } from "react-toastify";

const appointmentConstants = {
    ORDERS_REQUEST: 'ORDERS_REQUEST',
    ORDERS_RESPONSE: 'ORDERS_RESPONSE',
    APPT_REQUEST: 'APPT_REQUEST',
    APPT_RESPONSE: 'APPT_RESPONSE',
    AVA_DATE_REQUEST: 'AVA_DATE_REQUEST',
    AVA_DATE_RESPONSE: 'AVA_DATE_RESPONSE'
};

const initialState = {
    data: { containers: [] }, isLoading: false, isSaved: false, dataAva_dates:  [{ day: new Date(), capacity: 0 }] 
}

export const actionCreators = {
    getContainers: (ref) => async (dispatch, getState) => {
        const url = 'api/Shipment/ActDo/' + ref;
        dispatch({ type: appointmentConstants.ORDERS_REQUEST });
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            }
        })
            .then(handleResponse)
            .then(
                result => {
                    if (result.status === 200) {
                        dispatch({ type: appointmentConstants.ORDERS_RESPONSE, data: result.data })
                    } else {
                        console.log("TESTSETSET", result);
                        toast.warn("Error:" + result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                },
                error => {
                    if (error.status === 401) {
                        dispatch(push('/deliveryorder'));
                    } else {
                        toast.warn("Error:" + error.error, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                });
    },
    getAvaibleDates: (state, ref) => async (dispatch, getState) => {
        const url = 'api/Appointment/getCapacity';
        dispatch({ type: appointmentConstants.AVA_DATE_REQUEST });
        var obj = state;
        console.log("data", JSON.stringify(obj));
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
            body: JSON.stringify(obj),

        })
            .then(handleResponse)
            .then(
                result => { 
                    if (result != null && result != "undefined" && result != "") { 
                        dispatch({ type: appointmentConstants.AVA_DATE_RESPONSE, dataAva_dates: result })
                  
                    } else { 
                        toast.warn("Error:" + result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                },
                error => {
                    if (error.status === 401) {
                        dispatch(push('/deliveryorder'));
                    } else {
                        toast.warn("Error:" + error.error, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                });
    },
    saveAppointment: (state, ref) => async (dispatch, getState) => {
        const url = 'api/Appointment/saveAppt';
        dispatch({ type: appointmentConstants.APPT_REQUEST, isLoading: true });
        var obj = state;
        console.log("data", JSON.stringify(obj));
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + getState().account.user.token
            },
            body: JSON.stringify(obj),
        }).then(response => {
            if (response.status === 200) {
                dispatch({ type: appointmentConstants.APPT_RESPONSE, isLoading: false, isSaved: true });
                window.location.reload();
            }
        });
    }
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = text;
            return Promise.reject(error);
        }
        return data;
    });
}

export const reducer = (state, action) => {
    state = state || initialState;
    if (action.type === appointmentConstants.ORDERS_REQUEST) {
        return {
            ...state,
            isLoading: true,
            data: { containers: [] }
        };
    }

    else if (action.type === appointmentConstants.ORDERS_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isAuth: action.isAuth,
            data: action.data,
        };
    }
    else if (action.type === appointmentConstants.APPT_REQUEST) {
        return {
            ...state,
            isLoading: true,
            isSaved: false,
            isAuth: action.isAuth,
        };
    }
    else if (action.type === appointmentConstants.APPT_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isSaved: true,
            isAuth: action.isAuth,
        };
    }
    else if (action.type === appointmentConstants.AVA_DATE_REQUEST) {
        return {
            ...state,
            isLoading: true,
            dataAva_dates: [{ day: new Date(), capacity: 0 }] 
        };
    }
    else if (action.type === appointmentConstants.AVA_DATE_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            isAuth: action.isAuth,
            dataAva_dates: action.dataAva_dates,
        };
    }


    return state;
};



// WEBPACK FOOTER //
// ./src/store/AppointmentStore.js